// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3PRKz","description":"PatientConsentPreview_description__NMIlX"};